import Text from '@eduzz/houston-ui/Forms/Text';
import Typography from '@eduzz/houston-ui/Typography';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import { useObservable } from 'react-use-observable';
import eduzzAccountsService from 'v2/services/eduzzAccount';

interface IProps {
  success: boolean;
  sentEmail: boolean;
  message: string;
}

const DEFAULT_MESSAGE =
  'O relatório solicitado é muito grande para te entregarmos agora, mas fique tranquilo estamos gerando ele com cuidado e iremos enviar em seu email assim que estiver pronto!';

export const Content = ({ success, sentEmail, message = DEFAULT_MESSAGE }: IProps) => {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);

  return (
    <DialogContent dividers>
      {success ? (
        <Typography>
          Geração do relatório solicitada com sucesso, você irá receber o relatório no e-mail <b>{sentEmail || user?.email}</b> quando o processo
          finalizar.
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {message && (
            <Grid item xs={12}>
              <Typography>{message}</Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <Text
              placeholder={user?.email}
              id='email'
              name='email'
              label='E-mail'
              helperText='E-mail onde deseja receber o relatório, caso não informar, o mesmo será enviado em seu e-mail de cadastro.'
            />
          </Grid>
        </Grid>
      )}
    </DialogContent>
  );
};
